// @ts-nocheck
import siteMessage from "@insite/client-framework/SiteMessage";
import { OrderStateContext } from "@insite/client-framework/Store/Data/Orders/OrdersSelectors";
import WidgetModule from "@insite/client-framework/Types/WidgetModule";
import WidgetProps from "@insite/client-framework/Types/WidgetProps";
import { PageErrorWrapper, PageErrorWrapperStyles } from "@insite/content-library/Components/PageErrorWrapper";
import OrderLayout from "@store/Library/Components/Toolkit/Layout/OrderLayout";
import React, { useContext } from "react";

/* Store Custom Code - Start */
import useAppSelector from "@insite/client-framework/Common/Hooks/useAppSelector";
import translate from "@insite/client-framework/Translate";
import InfosBox, { InfosBoxProps } from "@store/Library/Components/Toolkit/InfosBox";
import { OrderLayoutStyles } from "@store/Library/Components/Toolkit/Layout/OrderLayout";
import { useRmaContext } from "@store/Framework/Components/RmaContext/RmaContext";
import { css } from "styled-components";
/* Store Custom Code - End */

export interface RequestRmaPageContainerStyles {
    pageErrorWrapper?: PageErrorWrapperStyles;
    // Store Custom Code
    orderLayout?: OrderLayoutStyles;
    successInfosBox?: InfosBoxProps;
}

export const requestRmaPageContainerStyles: RequestRmaPageContainerStyles = {
    /* Store Custom Code - Start */
    orderLayout: {
        sideColumnMobile: {
            // This column is aways empty because all buttons are sticky on mobile (see RequestRmaButtons.tsx)
            css: css`
                padding: 0 !important;
            `,
        },
    },
    successInfosBox: { type: "success" },
    /* Store Custom Code - End */
};

const styles = requestRmaPageContainerStyles;

const RequestRmaPageContainer = ({ id }: WidgetProps) => {
    const orderDataView = useContext(OrderStateContext);
    /* Store Custom Code - Start */
    const { isSubmitting, isSuccess } = useRmaContext();
    const resultMessage = useAppSelector(state => state.pages.requestRma.resultMessage);
    /* Store Custom Code - End */

    return (
        <PageErrorWrapper
            value={orderDataView}
            badRequestMessage={siteMessage("Order_BadRequest")}
            notAuthorizedMessage={siteMessage("Order_NotAuthorized")}
            notFoundMessage={siteMessage("Order_NotFound")}
            extendedStyles={styles.pageErrorWrapper}
        >
            {/* Store Custom Code - Start */}
            {isSuccess ? (
                <InfosBox {...styles.successInfosBox}>
                    {siteMessage(resultMessage || translate("Request submitted."))}
                </InfosBox>
            ) : (
                <OrderLayout id={id} loading={isSubmitting} extendedStyles={styles.orderLayout} />
            )}
            {/* Store Custom Code - End */}
        </PageErrorWrapper>
    );
};

const widgetModule: WidgetModule = {
    component: RequestRmaPageContainer,
    definition: {
        displayName: "Page Container",
        allowedContexts: ["RequestRmaPage"],
        fieldDefinitions: [],
        group: "Return Request (RMA)",
    },
};
export default widgetModule;
